module.exports = __webpack_public_path__ + "static/media/gears.85e5dfdf.svg";